import React from 'react';
import { motion } from 'framer-motion';

const ProjectSwitcher = ({ activeCategory, setActiveCategory, categories }) => {
    return (
        <div className="flex justify-center items-center my-8 w-[90%]">
            {/* Hlavný tmavý kontajner (kapsula) */}
            <div className="relative flex items-center p-1.5 bg-[#121212] border border-[#222] rounded-full w-full">
                {categories.map((category) => {
                    const isActive = activeCategory === category.id;

                    return (
                        <button
                            key={category.id}
                            onClick={() => setActiveCategory(category.id)}
                            className={`relative flex-1 px-6 py-2.5 text-sm font-medium transition-colors duration-300 rounded-full outline-none focus-visible:ring-2 focus-visible:ring-white z-10 ${isActive ? 'text-black' : 'text-[#888888] hover:text-white'
                                }`}
                        >
                            {/* Aktívne "puzdro", ktoré sa plynule kĺže */}
                            {isActive && (
                                <motion.div
                                    layoutId="active-pill"
                                    className="absolute inset-0 bg-white rounded-full -z-10"
                                    transition={{ type: 'spring', stiffness: 380, damping: 30 }}
                                />
                            )}
                            {category.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default ProjectSwitcher;
